{
  "generic.edit": "Bewerken",
  "generic.delete": "Verwijderen",
  "generic.update": "Bijwerken",
  "generic.create": "Aanmaken",
  "generic.cancel": "Annuleren",
  "generic.confirm": "Bevestigen",
  "generic.print": "Afdrukken",
  "generic.close": "Sluiten",
  "generic.save": "Opslaan",
  "generic.yes": "Ja",
  "generic.no": "Nee",
  "generic.save-validation": "Los fouten in het formulier op.",

  "input.select-certificate": "Selecteer een certificaat",
  "input.select-checklist": "Selecteer een checklist",
  "input.select-function": "Selecteer een functie",
  "input.select-organisation": "Selecteer een organisatie",
  "input.select-project": "Selecteer een project",
  "input.select-safety-instruction": "Selecteer een veiligheidsinstructie",
  "input.select-toolbox": "Selecteer een toolbox",

  "context-menu.tab-actions.close": "Sluit tabblad",
  "context-menu.tab-actions.close-all": "Sluit alle tabbladen",
  "context-menu.tab-actions.close-others": "Sluit andere tabbladen",
  "context-menu.tab-actions.split-horizontal": "Split horizontaal",
  "context-menu.tab-actions.split-vertical": "Split verticaal",
  "context-menu.tab-open.open": "Openen",
  "context-menu.tab-open.open-right": "Openen rechts",
  "context-menu.tab-open.open-bottom": "Openen onder",
  "menu.organisations": "Organisaties",
  "menu.people": "Personen",
  "menu.people.list": "Lijst",
  "menu.people.review": "Beoordelen",
  "menu.projects": "Projecten",
  "menu.certificates": "Certificaten",
  "menu.safety": "Veiligheids-rapporten",
  "menu.content": "Inhoud",
  "menu.instructions": "Instructies",
  "menu.checklists": "Checklists",
  "menu.toolboxes": "Toolboxen",
  "menu.thesaurus": "Functiehuis",
  "menu.app-users": "App-gebruikers",
  "menu.email-log": "E-maillog",
  "menu.section.platform": "Platformbeheer",
  "menu.account": "Account",

  "recompletion.title": "Moet iedereen dit opnieuw doorlopen?",
  "recompletion.message": "Je wijzigt inhoud die mensen al hebben afgerond. Is de wijziging zo ingrijpend dat zij die opnieuw moeten doorlopen? Kies \u2018Opnieuw laten doorlopen\u2019 om alle afrondingen te wissen, of \u2018Afrondingen behouden\u2019 om ze te laten staan.",
  "recompletion.keep": "Afrondingen behouden",
  "recompletion.reset": "Opnieuw laten doorlopen",

  "app-users.title": "App-gebruikers",
  "app-users.unnamed": "Naamloos account",
  "app-users.table.avatar": "Foto",
  "app-users.table.email": "E-mailadres",
  "app-users.table.first-name": "Voornaam",
  "app-users.table.last-name": "Achternaam",
  "app-users.table.nickname": "Roepnaam",
  "app-users.table.date-of-birth": "Geboortedatum",
  "app-users.table.organisations": "Organisaties",
  "app-users.table.last-login": "Laatst ingelogd",
  "app-users.table.never-logged-in": "Nooit ingelogd",
  "app-user-detail.load-error": "Kan de app-gebruiker niet laden",
  "app-user-detail.nickname": "Roepnaam",
  "app-user-detail.identity": "Identiteit",
  "app-user-detail.email": "E-mailadres",
  "app-user-detail.date-of-birth": "Geboortedatum",
  "app-user-detail.last-login": "Laatst ingelogd",
  "app-user-detail.person-records": "Persoonsregistraties",
  "app-user-detail.no-person-records": "Geen organisatie heeft een persoonsregistratie voor dit account.",
  "app-user-detail.wallet": "Wallet",
  "app-user-detail.wallet.empty": "Dit account heeft nog niets in zijn wallet.",
  "app-user-detail.wallet.employments": "Dienstverbanden",
  "app-user-detail.wallet.certificates": "Certificaten",
  "app-user-detail.wallet.content": "Afgeronde inhoud",
  "app-user-detail.wallet.company": "Onderneming",
  "app-user-detail.certificate-number": "Certificaatnummer",
  "app-user-detail.signed": "Ondertekend",
  "app-user-detail.not-signed": "Niet ondertekend",
  "app-user-detail.issued-by": "Uitgegeven door",
  "app-user-detail.portal-access": "Portaaltoegang",
  "app-user-detail.platform-admin": "Platformbeheerder",
  "app-user-detail.platform-admin.hint": "Geeft volledige toegang tot het beheerportaal, over alle organisaties heen.",
  "app-user-detail.platform-admin.yes": "Platformbeheerder",
  "app-user-detail.platform-admin.no": "Geen beheerder",
  "app-user-detail.platform-admin.grant": "Beheerder maken",
  "app-user-detail.platform-admin.revoke": "Beheerrechten intrekken",
  "app-user-detail.platform-admin.grant-confirm": "Dit account krijgt volledige toegang tot het beheerportaal, over alle organisaties heen. De toegang geldt vanaf de volgende keer inloggen.",
  "app-user-detail.platform-admin.revoke-confirm": "Dit account verliest de toegang tot het beheerportaal.",
  "app-user-detail.platform-admin.granted": "Het account is nu platformbeheerder",
  "app-user-detail.platform-admin.revoked": "De beheerrechten zijn ingetrokken",
  "app-user-detail.platform-admin.cannot-revoke-own": "Je kunt je eigen beheerrechten niet intrekken. Vraag een andere platformbeheerder om dit te doen.",
  "app-user-detail.platform-admin.error": "Kan de beheerrechten niet wijzigen",
  "attestation.status.Pending": "In afwachting",
  "attestation.status.Active": "Geldig",
  "attestation.status.Expired": "Verlopen",
  "attestation.status.Withdrawn": "Ingetrokken",

  "auth.login.title": "Inloggen bij het i-LOP platformportaal",
  "auth.login.description": "Gebruik je i-LOP-account om in te loggen op het platformportaal.",
  "auth.login.form.email": "E-mailadres",
  "auth.login.form.email.placeholder": "Voer je e-mailadres in",
  "auth.login.form.password": "Wachtwoord",
  "auth.login.form.password.placeholder": "Voer je wachtwoord in",
  "auth.login.form.submit": "Inloggen",
  "auth.login.form.yivi": "Inloggen met Yivi",
  "auth.login.form.forgot": "Wachtwoord vergeten?",
  "auth.forgot-password.title": "Wachtwoord vergeten",
  "auth.forgot-password.description": "Geen probleem! Vul hieronder je e-mailadres in en klik op 'Stuur resetlink'. Als je e-mailadres bij ons bekend is, ontvang je een link om je wachtwoord opnieuw in te stellen.",
  "auth.forgot-password.form.email": "E-mailadres",
  "auth.forgot-password.form.email.placeholder": "Voer je e-mailadres in",
  "auth.forgot-password.form.submit": "Stuur resetlink",
  "auth.forgot-password.form.back-to-login": "Terug naar inloggen",
  "auth.forgot-password.form.success.sent-to": "We hebben een bevestigingslink gestuurd naar",
  "auth.forgot-password.form.success.check-email": "Controleer je e-mail om je wachtwoord opnieuw in te stellen.",
  "auth.reset-password.title": "Wachtwoord opnieuw instellen",
  "auth.reset-password.description": "Je hebt gekozen om je wachtwoord opnieuw in te stellen. Gebruik het formulier hieronder om je nieuwe wachtwoord in te voeren. Zodra je het hebt bijgewerkt, moet je opnieuw inloggen.",
  "auth.reset-password.form.password": "Nieuw wachtwoord",
  "auth.reset-password.form.password.placeholder": "Voer je nieuwe wachtwoord in",
  "auth.reset-password.form.password-confirm": "Bevestig nieuw wachtwoord",
  "auth.reset-password.form.password-confirm.placeholder": "Voer je nieuwe wachtwoord opnieuw in",
  "auth.reset-password.form.submit": "Wachtwoord wijzigen",
  "auth.reset-password.form.success": "Je wachtwoord is succesvol gewijzigd. Je kunt nu inloggen met je nieuwe wachtwoord.",
  "auth.reset-password.form.back-to-login": "Terug naar inloggen",
  "auth.reset-password.form.password-mismatch": "De wachtwoorden komen niet overeen. Controleer je invoer en probeer het opnieuw.",
  "table.per-page": "Items per pagina:",
  "table.empty.title": "Geen gegevens gevonden",
  "table.empty.sub-title": "Er zijn geen resultaten voor je huidige selectie. Probeer om je filters aan te passen of maak een nieuw item aan.",
  "table.toast.error": "Er is een fout opgetreden bij het ophalen van de gegevens",
  "organisations.table.logo": "Logo",
  "organisations.table.organisation-name": "Organisatienaam",
  "organisations.table.business-registry-number": "KvK-nummer",
  "organisations.table.city": "Plaatsnaam",
  "organisations.table.street-name": "Straat",
  "organisations.table.website": "Website",
  "organisations.new": "Nieuwe organisatie",
  "organisations.title": "Lijst van organisaties",
  "organisation-edit.edit-title": "Organisatie bewerken",
  "organisation-edit.new-title": "Nieuwe organisatie",
  "organisation-edit.delete-button": "Verwijder organisatie",
  "organisation-edit.delete-title": "Organisatie verwijderen",
  "organisation-edit.delete-confirm": "Verwijderen",
  "organisation-edit.delete-message": "Weet je zeker dat je deze organisatie wilt verwijderen?",
  "organisation-edit.delete-success": "Organisatie succesvol verwijderd.",
  "organisation-edit.delete-error": "Er is een fout opgetreden bij het verwijderen van de organisatie.",
  "organisation-edit.roles-load-error": "Je rechten voor deze organisatie konden niet worden bepaald; de organisatie wordt alleen-lezen weergegeven.",
  "organisation-edit.manage-role-assignments": "Rolverdeling beheren",
  "organisation-edit.manage-safety-requirements": "Veiligheidseisen beheren",
  "organisation-form.general-data": "Algemene gegevens",
  "organisation-form.visitor-address": "Bezoekadres",
  "organisation-form.postal-address": "Postadres",
  "organisation-form.active": "Actief",
  "organisation-form.logo": "Logo",
  "organisation-form.click-to-upload-logo": "Klik om logo te uploaden",
  "organisation-form.remove-logo": "Verwijder logo",
  "organisation-form.coc-number": "KvK-nummer",
  "organisation-form.organisation-name": "Organisatienaam",
  "organisation-form.description": "Omschrijving",
  "organisation-form.description.required": "Omschrijving is verplicht",
  "organisation-form.description.not-translated": "Vertaal de omschrijving alstublieft in alle talen",
  "organisation-form.parent-organisation": "Moederorganisatie",
  "organisation-form.email-address": "E-mailadres",
  "organisation-form.website": "Website",
  "organisation-form.phone-number": "Telefoonnummer",
  "organisation-form.oin-number": "OIN-nummer",
  "organisation-form.city": "Plaats",
  "organisation-form.street": "Straat",
  "organisation-form.house-number": "Huisnummer",
  "organisation-form.zip-code": "Postcode",
  "organisation-form.save-success": "Organisatie succesvol opgeslagen.",
  "organisation-form.save-error": "Er is een fout opgetreden bij het opslaan van de organisatie.",
  "organisation-form.save-validation": "Los eerst de fouten in het formulier op.",
  "organisation-form.website.invalid": "Voer een geldige URL in (beginnend met http:// of https://)",
  "PlatformAdmin": "Platformbeheerder",
  "app-role.View": "Inchecken",
  "app-role.Admin": "Beheerder",
  "app-role.SafetyCoordinator": "Veiligheidscoordinator",
  "app-role.Foreman": "Uitvoerder",
  "toast.error": "Foutmelding",
  "toast.success": "Gelukt",
  "toast.warning": "Waarschuwing",
  "toast.info": "Informatie",
  "password-complexity.requirements": "Wachtwoorden moeten ten minste voldoen aan:",
  "password-complexity.min-length": "Minimaal {{minLength}} karakters",
  "password-complexity.uppercase": "Minimaal één hoofdletter",
  "password-complexity.lowercase": "Minimaal één kleine letter",
  "password-complexity.digit": "Minimaal één cijfer",
  "password-complexity.special-char": "Minimaal één speciaal teken",
  "errors.authentication.invalid": "Je e-mailadres of wachtwoord klopt niet",
  "errors.authentication.try_later": "Het is momenteel niet mogelijk om in te loggen. Probeer het later opnieuw.",
  "errors.authentication.generic": "Er is een fout opgetreden bij het inloggen. Probeer het opnieuw.",
  "errors.authentication.yivi_failed": "Inloggen met Yivi is niet gelukt. Probeer het opnieuw.",
  "errors.reset.generic": "Mogelijk is dit token om je wachtwoord opnieuw in te stellen al gebruikt of is het verlopen. Probeer het opnieuw.",
  "errors.invitation.generic": "De uitnodiging kon niet worden verzonden. Probeer het opnieuw.",
  "errors.invitation.already-accepted": "Dit dienstverband is al geaccepteerd; er valt niets uit te nodigen.",
  "errors.invitation.not-invitable": "Dit dienstverband is afgewezen of beëindigd; het kan niet worden uitgenodigd.",
  "errors.invitation.email-failed": "De uitnodigingsmail kon niet worden verzonden. Probeer het opnieuw om dezelfde link nogmaals te versturen.",
  "errors.withdrawal.generic": "Het dienstverband kon niet worden ingetrokken. Probeer het opnieuw.",
  "errors.withdrawal.end-date-not-removed": "De einddatum kon niet worden verwijderd. Probeer het opnieuw.",
  "errors.employment.approval-remark-required": "Je hebt het dienstverbandverzoek aangepast; voeg een opmerking voor de medewerker toe voordat je goedkeurt.",
  "errors.revocation.generic": "Het aanbod kon niet worden ingetrokken. Probeer het opnieuw.",
  "errors.withdrawal.not-withdrawable": "Alleen een geaccepteerd dienstverband kan worden ingetrokken.",
  "errors.withdrawal.already-withdrawn": "Dit dienstverband is al ingetrokken. Een intrekking is definitief en kan niet worden gewijzigd.",
  "errors.withdrawal.date-invalid": "De einddatum kan niet voor de startdatum liggen.",
  "errors.withdrawal.not-revocable": "Dit aanbod is al geaccepteerd; trek het dienstverband in.",
  "auth.invalid-role.title": "Geen toegang",
  "auth.invalid-role.description": "Je hebt met dit account geen toegang tot deze applicatie. Neem contact op met je systeembeheerder voor meer informatie.",
  "auth.invalid-role.back-to-login": "Terug naar inloggen",
  "context-menu.account.logout": "Uitloggen",
  "errors.generic": "Er is een fout opgetreden. Probeer het opnieuw.",
  "errors.person.email-duplicate": "Er bestaat al een persoon met dit e-mailadres.",
  "organisation-edit.admins": "Beheerders",
  "invite-or-add-person-modal.title": "Persoon uitnodigen of toevoegen",
  "invite-or-add-person-modal.description": "Gebruik deze modal om een nieuwe persoon uit te nodigen of een bestaande persoon aan de organisatie toe te voegen. Vul eerst het e-mailadres in van de persoon die je wilt toevoegen. Als deze nog niet geregistreerd is, moet je de gegevens invullen.",
  "invite-or-add-person-modal.step2.description": "Deze persoon bestaat nog niet. Vul hieronder de gegevens in.",
  "invite-or-add-person-modal.form.email": "E-mailadres",
  "invite-or-add-person-modal.form.email.placeholder": "Voer het e-mailadres in van de persoon die je wilt toevoegen",
  "invite-or-add-person-modal.next": "Volgende",
  "invite-or-add-person-modal.cancel": "Annuleren",
  "invite-or-add-person-modal.back": "Terug",
  "invite-or-add-person-modal.create": "Toevoegen",
  "add-person-by-email-modal.title": "Persoon toevoegen",
  "add-person-by-email-modal.description": "Voer een e-mailadres in om te controleren of deze persoon al bestaat.",
  "add-person-by-email-modal.form.email": "E-mailadres",
  "add-person-by-email-modal.continue": "Doorgaan",
  "add-person-by-email-modal.multiple-matches": "Er zijn meerdere personen gevonden met dit e-mailadres. Selecteer de persoon van de juiste organisatie.",
  "add-person-by-email-modal.back": "Terug",
  "edit-person-role-modal.title": "Rol van persoon bewerken",
  "edit-person-role-modal.description": "Gebruik deze modal om de rol van de persoon binnen de organisatie te bewerken.",
  "edit-person-role-modal.form.role": "Rol",
  "edit-person-role-modal.form.role.placeholder": "Selecteer rol",
  "edit-person-role-modal.save": "Opslaan",
  "edit-person-role-modal.cancel": "Annuleren",
  "context-menu.person-reference.remove": "Persoon verwijderen",
  "context-menu.person-reference.change-role": "Rol wijzigen",
  "projects.table.logo": "Logo",
  "projects.table.project-name": "Projectnaam",
  "projects.table.project-code": "Projectcode",
  "projects.table.client": "Opdrachtgever",
  "projects.table.contractor": "Opdrachtnemer",
  "projects.table.owner": "Projectbeheerder",
  "projects.table.city": "Stad",
  "projects.table.street-name": "Straat",
  "projects.new": "Nieuw project",
  "projects.title": "Lijst van projecten",
  "project-edit.title-edit": "Project bewerken",
  "project-edit.title-new": "Nieuw project",
  "project-edit.delete": "Project verwijderen",
  "project-edit.close": "Sluiten",
  "project-edit.manage-role-assignments": "Roltoewijzingen beheren",
  "project-edit.manage-safety-requirements": "Veiligheidseisen beheren",
  "project-edit.manage-alerts": "Berichten beheren",
  "project-edit.manage-day-registrations": "Dagregistraties",
  "project-edit.delete-button": "Project verwijderen",
  "project-edit.delete-title": "Project verwijderen",
  "project-edit.delete-message": "Weet je zeker dat je dit project wilt verwijderen?",
  "project-edit.delete-confirm": "Verwijderen",
  "project-edit.delete-success": "Project succesvol verwijderd.",
  "project-edit.delete-error": "Er is een fout opgetreden bij het verwijderen van het project.",
  "project-edit.qr-code-button": "QR-code",
  "project-edit.qr-code-modal-title": "Project QR-code",
  "project-edit.qr-code-modal-alt": "Project QR-code afbeelding",
  "project-edit.load-error": "Fout bij het laden van het project.",
  "project-form.general-data": "Algemene gegevens",
  "project-form.address": "Adres",
  "project-form.title": "Titel",
  "project-form.logo": "Logo",
  "project-form.click-to-upload-logo": "Klik om logo te uploaden",
  "project-form.remove-logo": "Verwijder logo",
  "project-form.active": "Actief",
  "project-form.description": "Omschrijving",
  "project-form.project-code": "Projectcode",
  "project-form.client": "Opdrachtgever",
  "project-form.contractor": "Opdrachtnemer",
  "project-form.owner": "Projectbeheerder",
  "project-form.chief-safety-officer": "Hoofd veiligheidsfunctionaris:",
  "project-form.start-date": "Startdatum",
  "project-form.end-date": "Einddatum",
  "project-form.city": "Stad",
  "project-form.street": "Straat",
  "project-form.house-number": "Huisnummer",
  "project-form.zip-code": "Postcode",
  "project-form.party-organisation": "Organisatie",
  "project-form.organisation-none": "Geen",
  "project-form.admins": "Projectbeheerders",
  "project-form.safety-contact": "Veiligheidsaanspreekpunt",
  "project-form.safety-contact.select": "Selecteer Veiligheidsaanspreekpunt",
  "project-form.safety-contact.select-contractor-first": "Selecteer eerst een opdrachtnemer",
  "project-form.safety-director": "Regievoerder Veiligheid",
  "project-form.safety-director.select": "Selecteer Regievoerder Veiligheid",
  "project-form.safety-director.select-client-first": "Selecteer eerst een opdrachtgever",
  "project-form.project-risks": "Projectrisico's",
  "project-form.collision-hazard": "Aanrijdgevaar",
  "project-form.falling-from-height": "Vallen van hoogte",
  "project-form.electrocution": "Elektrocutie",
  "project-form.hoisting-and-transport": "Hijsen en transport van bouwdelen",
  "project-form.hazardous-substances": "Gevaarlijke stoffen",
  "project-form.save-success": "Project succesvol opgeslagen.",
  "project-form.save-error": "Er is een fout opgetreden bij het opslaan van het project.",
  "project-form.save-validation": "Los eerst de fouten in het formulier op.",
  "project-alerts.page-title": "Berichten voor",
  "project-alerts.create-button": "Bericht aanmaken",
  "project-alerts.create-title": "Bericht aanmaken",
  "project-alerts.edit-title": "Bericht bewerken",
  "project-alerts.empty": "Er zijn nog geen berichten voor dit project.",
  "project-alerts.valid-from": "Geldig vanaf",
  "project-alerts.valid-until": "Geldig tot",
  "project-alerts.target-audience": "Doelgroep",
  "project-alerts.table.title": "Titel",
  "project-alerts.table.category": "Categorie",
  "project-alerts.table.type": "Type",
  "project-alerts.table.valid-from": "Geldig vanaf",
  "project-alerts.table.valid-until": "Geldig tot",
  "project-alerts.table.target-audience": "Doelgroep",
  "project-alerts.table.translations": "Videovertalingen",
  "project-alerts.table.no-translations": "Geen",
  "project-alerts.form.title": "Titel",
  "project-alerts.form.title-placeholder": "Voer een berichttitel in",
  "project-alerts.form.type": "Type",
  "project-alerts.form.category": "Categorie",
  "project-alerts.form.language": "Taal",
  "project-alerts.form.type-text": "Tekstbericht",
  "project-alerts.form.type-video": "Videobericht",
  "project-alerts.form.description": "Beschrijving",
  "project-alerts.form.video": "Video",
  "project-alerts.form.choose-video": "Video kiezen",
  "project-alerts.form.saved-video": "Opgeslagen video",
  "project-alerts.form.video-required": "Selecteer een video.",
  "project-alerts.form.video-upload-failed": "Uploaden van video is mislukt.",
  "project-alerts.form.translate-video": "Geuploade video automatisch vertalen",
  "project-alerts.form.valid-from": "Geldig vanaf",
  "project-alerts.form.valid-until": "Geldig tot",
  "project-alerts.form.date-order-error": "Geldig tot moet op of na geldig vanaf liggen.",
  "project-alerts.category.General": "Algemeen",
  "project-alerts.category.Weather": "Weer",
  "project-alerts.category.Logistic": "Logistiek",
  "project-alerts.category.Safety": "Veiligheid",
  "project-alerts.translations": "Vertalingen",
  "project-alerts.create-success": "Bericht succesvol aangemaakt.",
  "project-alerts.create-error": "Er is een fout opgetreden bij het aanmaken van het bericht.",
  "project-alerts.update-success": "Bericht succesvol bijgewerkt.",
  "project-alerts.update-error": "Er is een fout opgetreden bij het bijwerken van het bericht.",
  "project-alerts.delete-title": "Bericht verwijderen",
  "project-alerts.delete-message": "Weet je zeker dat je dit bericht wilt verwijderen?",
  "project-alerts.delete-confirm": "Verwijderen",
  "project-alerts.delete-success": "Bericht succesvol verwijderd.",
  "project-alerts.delete-error": "Er is een fout opgetreden bij het verwijderen van het bericht.",
  "project-day-registrations.page-title": "Dagregistraties voor",
  "project-day-registrations.table.worker": "Medewerker",
  "project-day-registrations.table.company": "Bedrijf",
  "project-day-registrations.table.check-in": "Inchecken",
  "project-day-registrations.table.check-out": "Uitchecken",
  "project-day-registrations.table.still-on-site": "Nog op locatie",
  "project-day-registrations.table.duration": "Duur",
  "project-day-registrations.table.unknown-worker": "Onbekende medewerker",
  "project-day-registrations.table.unknown-company": "Onbekend bedrijf",
  "project-day-registrations.table.swi-signed": "SWI ondertekend",
  "project-day-registrations.table.swi-signed-yes": "Ondertekend",
  "project-day-registrations.table.swi-signed-no": "Niet ondertekend",
  "project-day-registrations.detail.title": "Dagregistratie",
  "project-day-registrations.detail.registration": "Registratie",
  "project-day-registrations.detail.swi": "Start Werk Instructie",
  "project-day-registrations.detail.signed-at": "Ondertekend op",
  "project-day-registrations.detail.signature": "Handtekening",
  "project-day-registrations.detail.not-signed": "Geen ondertekende Start Werk Instructie voor deze registratie.",
  "project-day-registrations.detail.load-error": "Deze dagregistratie kon niet geladen worden",
  "certificates.title": "Certificaten",
  "certificates.tab-definitions": "Definities",
  "certificates.tab-for-review": "Ter beoordeling",
  "certificates.tab-accomplished": "Overzicht",
  "certificates.new": "Nieuw Certificaat",
  "certificates.logo": "Logo",
  "certificates.name": "Naam",
  "certificates.description": "Beschrijving",
  "certificates.issuingOrganisations": "Uitgevende Organisaties",
  "certificates.gracePeriod": "Uitstelperiode",
  "certificates.days": "dagen",
  "certificates.showOnWorker": "Tonen bij werknemer",
  "certificates.form.showOnWorker": "Tonen op werknemerdetailpagina",
  "certificates.form.showOnWorkerLabel": "Markeer houders van dit certificaat in de app",
  "certificates.newTitle": "Nieuw Certificaat",
  "certificates.editTitle": "Certificaat Bewerken",
  "certificates.loadError": "Fout bij het laden van certificaat",
  "certificates.loadOrganisationsError": "Fout bij het laden van organisaties",
  "certificates.loadRegistriesError": "Fout bij het laden van certificaatregisters",
  "certificates.createSuccess": "Certificaat succesvol aangemaakt",
  "certificates.createError": "Fout bij het aanmaken van certificaat",
  "certificates.updateSuccess": "Certificaat succesvol bijgewerkt",
  "certificates.updateError": "Fout bij het bijwerken van certificaat",
  "certificates.deleteSuccess": "Certificaat succesvol verwijderd",
  "certificates.deleteError": "Fout bij het verwijderen van certificaat",
  "certificates.logoRequired": "Logo is verplicht voor nieuwe certificaten",
  "certificates.fileError": "Fout bij het verwerken van bestand",
  "certificates.error.registryConflict": "Deze Registerbron is al toegewezen aan een ander certificaat",
  "certificates.invalidFileType": "Selecteer een geldig afbeeldingsbestand",
  "certificates.fileTooLarge": "Bestandsgrootte moet kleiner zijn dan 5MB",
  "certificates.confirmDelete.title": "Certificaat Verwijderen",
  "certificates.confirmDelete.message": "Weet je zeker dat je dit certificaat wilt verwijderen?",
  "certificates.form.name": "Certificaatnaam",
  "certificates.form.namePlaceholder": "Voer certificaatnaam in",
  "certificates.form.description": "Beschrijving",
  "certificates.form.descriptionPlaceholder": "Voer certificaatbeschrijving in",
  "certificates.form.logo": "Logo",
  "certificates.form.logoPlaceholder": "Kies certificaatlogo",
  "certificates.form.logoBackgroundColor": "Logo Achtergrondkleur",
  "certificates.form.logoBackgroundColorPlaceholder": "Voer achtergrondkleur in (bijv. #ffffff)",
  "certificates.form.issuingOrganisation": "Uitgevende Organisatie",
  "certificates.form.issuingOrganisationPlaceholder": "Selecteer uitgevende organisatie",
  "certificates.form.issuingOrganisations": "Uitgevende Organisaties",
  "certificates.form.issuingOrganisationsPlaceholder": "Selecteer uitgevende organisaties",
  "certificates.form.gracePeriod": "Uitstelperiode (Dagen)",
  "certificates.form.gracePeriodPlaceholder": "Voer uitstelperiode in dagen in",
  "certificates.form.registrySource": "Registerbron",
  "certificates.form.registrySourcePlaceholder": "Selecteer registerbron (optioneel)",
  "certificates.form.validityYears": "Geldigheidsduur (Jaren, optioneel)",
  "certificates.form.validityYearsPlaceholder": "Voer geldigheidsduur in",
  "certificates-review.empty-state": "Geen certificaten in afwachting van beoordeling",
  "certificates-review.person": "Persoon",
  "certificates-review.certificate": "Certificaat",
  "certificates-review.certificate-number": "Certificaatnummer",
  "certificates-review.submitted-on": "Ingediend op",
  "certificates-review.date-of-birth": "Geboortedatum",
  "certificates-review.issued-on": "Uitgegeven op",
  "certificates-review.expires-on": "Geldig tot",
  "certificates-review.document": "Documenten",
  "certificates-review.view-document": "Document bekijken",
  "certificates-review.view-document-n": "Document {n} bekijken",
  "certificates-review.approve": "Goedkeuren",
  "certificates-review.reject": "Afwijzen",
  "certificates-review.approved-success": "Certificaat succesvol goedgekeurd",
  "certificates-review.rejected-success": "Certificaat succesvol afgewezen",
  "certificates-review.error": "Er is iets misgegaan. Probeer het opnieuw.",
  "certificates-review.error-load": "Certificaten laden mislukt",
  "certificates-review.not-found": "Certificaat niet gevonden",
  "certificates-review.person-details": "Persoon",
  "certificates-review.certificate-details": "Certificaat",
  "certificates-review.status-approved": "Goedgekeurd",
  "certificates-review.status-rejected": "Afgekeurd",
  "certificates-review.rejection-reason": "Reden voor afwijzing",
  "certificates-review.rejection-reason-placeholder": "Optionele reden voor afwijzing",
  "certificates-review.confirm-reject": "Afwijzing bevestigen",
  "certificates-review.cancel-reject": "Annuleren",
  "certificates-review.rejection-modal-title": "Certificaat afwijzen",
  "certificates-review.rejection-modal-description": "Geef optioneel een reden op. Deze wordt meegestuurd in de afwijzingsmelding aan de gebruiker.",
  "certificates-accomplished.select-organisation": "Selecteer een organisatie om behaalde certificaten te bekijken",
  "certificates-accomplished.person": "Persoon",
  "certificates-accomplished.holder-name": "Naam houder",
  "certificates-accomplished.certificate": "Certificaat",
  "certificates-accomplished.date-of-birth": "Geboortedatum",
  "certificates-accomplished.expires-on": "Geldig tot",
  "certificates-accomplished.source": "Bron",
  "certificates-accomplished.source-registry": "Register",
  "certificates-accomplished.source-manual": "Handmatig",
  "certificates-accomplished.status": "Status",
  "certificates-accomplished.status-valid": "Geldig",
  "certificates-accomplished.status-about-to-expire": "Verloopt binnenkort",
  "certificates-accomplished.status-expired": "Verlopen",
  "common.edit": "Bewerken",
  "common.delete": "Verwijderen",
  "common.actions": "Acties",
  "common.create": "Aanmaken",
  "common.update": "Bijwerken",
  "common.global": "Globaal",
  "content-owner.label": "Eigenaar",
  "content-owner.global": "Globaal",
  "content-owner.organisation": "Organisatie",
  "content-owner.organisation.required": "Organisatie is verplicht",
  "content-owner.project": "Project",
  "content-owner.project.required": "Project is verplicht",
  "project-form.end-date-before-start-date": "De einddatum kan niet voor de startdatum liggen.",
  "persons.table.avatar": "Profielfoto",
  "persons.table.first-name": "Voornaam",
  "persons.table.last-name": "Achternaam",
  "persons.table.email": "E-mailadres",
  "persons.table.employments": "Dienstverbanden",
  "persons.table.last-login": "Laatste login",
  "persons.table.never-logged-in": "Nooit ingelogd",
  "persons.table.actions": "Acties",
  "persons.table.invitation-status": "Uitnodigingsstatus",
  "persons.new": "Nieuwe Persoon",
  "persons.title": "Lijst van Personen",
  "persons.already-has-account": "Deze persoon heeft al een account",
  "persons.invitation-sent": "Uitnodiging succesvol verzonden",
  "persons.invitation-status.accepted": "Geaccepteerd",
  "persons.invitation-status.expired": "Verlopen",
  "persons.invitation-status.invited": "Uitgenodigd",
  "persons.invitation-status.not-invited": "Niet uitgenodigd",
  "person-edit.title-edit": "Persoon Bewerken",
  "person-edit.title-new": "Nieuwe Persoon",
  "person-edit.binding-anomaly-warning": "De dienstverbanden van deze persoon zijn gekoppeld aan meer dan één app-account. Dit is een dataprobleem — neem contact op met support om dit op te lossen voordat je dienstverbanden beheert.",
  "person-edit.delete": "Persoon Verwijderen",
  "person-edit.close": "Sluiten",
  "person-edit.delete-button": "Persoon Verwijderen",
  "person-edit.delete-title": "Persoon Verwijderen",
  "person-edit.delete-message": "Weet je zeker dat je deze persoon wilt verwijderen?",
  "person-edit.delete-confirm": "Verwijderen",
  "person-edit.delete-success": "Persoon succesvol verwijderd.",
  "person-edit.delete-error": "Er is een fout opgetreden bij het verwijderen van de persoon.",
  "person-edit.already-has-account": "Deze persoon heeft al een account",
  "person-edit.invite-button": "Stuur uitnodiging",
  "person-edit.reinvite-button": "Stuur uitnodiging opnieuw",
  "person-edit.edit-forbidden": "Je hebt geen toegang om deze persoon te bewerken.",
  "person-edit.manage-role-assignments": "Rolverdeling beheren",
  "person-role-assignments.scope": "Bereik",
  "person-role-assignments.scope-name": "Toegekend in",
  "person-role-assignments.scope-Organisation": "Organisatie",
  "person-role-assignments.scope-Project": "Project",
  "person-role-assignments.add-validation": "Selecteer een bereik en een rol.",
  "person-role-assignments.add-success": "Rolverdeling toegevoegd.",
  "person-role-assignments.add-forbidden": "Je bent geen beheerder van het geselecteerde project.",
  "person-role-assignments.add-duplicate": "Deze persoon heeft deze rol hier al.",
  "person-role-assignments.add-rejected-organisation": "Deze rol kan niet op organisatieniveau worden toegekend.",
  "person-role-assignments.no-organisation": "Deze persoon heeft geen organisatie, dus alleen projectrollen kunnen worden toegekend.",
  "person-form.avatar": "Profielfoto",
  "person-form.avatar.remove": "Verwijder foto",
  "person-form.general-data": "Algemene Gegevens",
  "person-form.first-name": "Voornaam",
  "person-form.first-name.placeholder": "Voer voornaam in",
  "person-form.last-name": "Achternaam",
  "person-form.last-name.placeholder": "Voer achternaam in",
  "person-form.email": "E-mailadres",
  "person-form.email.placeholder": "Voer e-mailadres in",
  "person-form.gender": "Geslacht",
  "person-form.gender.male": "Man",
  "person-form.gender.female": "Vrouw",
  "person-form.gender.other": "Anders",
  "person-form.date-of-birth": "Geboortedatum",
  "person-form.date-of-birth.placeholder": "Voer geboortedatum in",
  "person-form.organisation": "Organisatie",
  "person-form.role": "Rol",
  "person-form.role.placeholder": "Selecteer rol",
  "person-form.employments": "Dienstverbanden",
  "person-form.save-success": "Persoon succesvol opgeslagen.",
  "person-form.save-error": "Er is een fout opgetreden bij het opslaan van de persoon.",
  "person-form.save-validation": "Los eerst de fouten in het formulier op.",
  "person-form.employment-required": "Minstens één dienstverband is vereist.",
  "person-form.select-organisation-first": "Selecteer eerst de organisatie van de persoon voordat je een dienstverband toevoegt.",
  "employment.create-title": "Nieuw dienstverband toevoegen",
  "employment.edit-title": "Dienstverband bewerken",
  "employment.organisation": "Organisatie",
  "employment.function": "Functie",
  "employment.function-placeholder": "Selecteer functie",
  "employment.start-date": "Startdatum",
  "employment.end-date": "Einddatum (optioneel)",
  "employment.end-date-read-only": "Gebruik Dienstverband intrekken om dit te wijzigen — daar wordt de reden vastgelegd.",
  "employment.start-date-after-end-date": "De startdatum kan niet na de einddatum liggen.",
  "employment.managerial": "Leidinggevend",
  "employment.managerial-label": "Leidinggevende rol",
  "employment.active": "Actief",
  "employment.inactive": "Inactief",
  "employment.statusForAdminReview": "Beheerdersbeoordeling",
  "employment.statusForUserReview": "Gebruikersbeoordeling",
  "employment.invitation.not-invited": "Nog niet uitgenodigd",
  "employment.invitation.invited": "Uitgenodigd",
  "employment.invitation.expired": "Uitnodiging verlopen",
  "employment.withdrawn": "Ingetrokken",
  "employment.withdrawn-by": "Ingetrokken door {{name}} op {{date}}",
  "employment.end-date-removed-by": "Einddatum verwijderd door {{name}} op {{date}}",
  "employment.withdrawn-by-unknown": "een beheerder",
  "employment.withdraw.action": "Dienstverband intrekken",
  "employment.withdraw.title": "Dienstverband intrekken",
  "employment.withdraw.message": "Het dienstverband houdt toegang tot de ingangsdatum van de intrekking. De intrekking wordt vastgelegd met jouw naam, de datum en de reden.",
  "employment.withdraw.effective-end-date": "Einddatum",
  "employment.withdraw.effective-end-date-hint": "De toegang eindigt aan het begin van deze datum.",
  "employment.withdraw.last-day-with-access": "Laatste dag met toegang: {{date}}",
  "employment.withdraw.remove-end-date": "Geen einddatum (het dienstverband blijft doorlopen)",
  "employment.withdraw.no-end-date-hint": "Het dienstverband houdt toegang tot er weer een einddatum wordt ingesteld.",
  "employment.withdraw.reason": "Reden",
  "employment.approved-with-changes": "Goedgekeurd met wijzigingen op het verzoek van de medewerker",
  "employment.approval-remark": "Opmerking",
  "employment.withdraw.confirm": "Intrekken",
  "employment.withdraw.confirm-remove": "Einddatum verwijderen",
  "employment.withdraw.end-date-removed": "Einddatum verwijderd.",
  "employment.withdraw.success": "Dienstverband ingetrokken.",
  "employment.withdraw.ends-on": "Toegang eindigt op {{date}}",
  "employment.revoke-action": "Aanbod intrekken",
  "employment.revoke-confirm-title": "Aanbod dienstverband intrekken",
  "employment.revoke-confirm-message": "Het aanbod wordt verwijderd en de uitnodigingslink werkt niet meer. Er was nog niets toegekend, dus er blijft niets bewaard. Doorgaan?",
  "employment.revoke-success": "Aanbod dienstverband ingetrokken.",
  "employment.create-success": "Dienstverband succesvol aangemaakt.",
  "employment.create-error": "Er is een fout opgetreden bij het aanmaken van het dienstverband.",
  "employment.update-success": "Dienstverband succesvol bijgewerkt.",
  "employment.update-error": "Er is een fout opgetreden bij het bijwerken van het dienstverband.",
  "employment.delete-success": "Dienstverband succesvol verwijderd.",
  "employment.delete-error": "Er is een fout opgetreden bij het verwijderen van het dienstverband.",
  "employment.delete-confirm-title": "Dienstverband verwijderen",
  "employment.delete-confirm-message": "Weet je zeker dat je dit dienstverband wilt verwijderen? Deze actie kan niet ongedaan worden gemaakt.",
  "employment.timeline.no-employments": "Geen dienstverband geschiedenis beschikbaar.",
  "employment.timeline.add-employment": "Dienstverband toevoegen",
  "employment.timeline.present": "Huidig",
  "context-menu.generic-view.view": "Bekijken",
  "context-menu.generic-update-delete.edit": "Bewerken",
  "context-menu.generic-update-delete.delete": "Verwijderen",

  "role-assignments.title": "Rolverdelingen voor",
  "role-assignments.search-placeholder": "Zoek personen of organisaties...",
  "role-assignments.role-placeholder": "Selecteer een rol...",
  "role-assignments.add-assignment": "Rolverdeling toevoegen",
  "role-assignments.avatar-alt": "Avatar of logo",
  "role-assignments.send-invite-to": "Uitnodiging versturen naar:",
  "role-assignments.edit-title": "Rolverdeling bewerken",
  "role-assignments.principal-label": "Betrokkene",
  "role-assignments.role-label": "Rol",
  "role-assignments.save": "Opslaan",
  "role-assignments.saving": "Bezig met opslaan...",
  "role-assignments.role-required": "Rol is verplicht.",
  "role-assignments.update-success": "Rol succesvol bijgewerkt",
  "role-assignments.update-error": "Bijwerken van rol mislukt",
  "role-assignments.add-error": "Toevoegen van rolverdeling mislukt.",
  "role-assignments.delete-error": "Verwijderen van rolverdeling mislukt.",
  "role-assignments.add-validation": "Selecteer een persoon/organisatie en een rol.",
  "role-assignments.name": "Naam",
  "role-assignments.email": "E-mail",
  "role-assignments.type": "Type",
  "role-assignments.role": "Rol",
  "role-assignments.delete-title": "Rolverdeling verwijderen",
  "role-assignments.delete-message": "Weet je zeker dat je deze roldeling wilt verwijderen?",
  "safety-reports.title-all": "Alle veiligheidsrapporten",
  "safety-reports.category.Accident": "Ongeval",
  "safety-reports.category.UnsafeSituation": "Onveilige situatie",
  "safety-reports.category.SafeSituation": "Veilige situatie",
  "safety-reports.status.New": "Nieuw",
  "safety-reports.status.InProgress": "In behandeling",
  "safety-reports.status.Solved": "Opgelost",
  "safety-reports.status.OnHold": "Gepauzeerd",
  "safety-reports.table.status": "Status",
  "safety-reports.table.reporter": "Melder",
  "safety-reports.table.project": "Project",
  "safety-reports.table.assigned-to": "Toegewezen aan",
  "safety-reports.table.description": "Beschrijving",
  "safety-reports.table.category": "Categorie",
  "safety-reports.table.date-created": "Datum aangemaakt",
  "safety-reports.unassigned": "Niet toegewezen",
  "safety-report-detail.error.title": "Laden van veiligheidsrapport mislukt",
  "safety-report-detail.title": "Veiligheidsrapport #{{id}}",
  "safety-report-detail.urgent": "Urgent",
  "safety-report-detail.normal": "Normaal",
  "safety-report-detail.anonymous": "Anoniem",
  "safety-report-detail.sections.details": "Details",
  "safety-report-detail.sections.status": "Status",
  "safety-report-detail.sections.logs": "Logboek",
  "safety-report-detail.sections.comments": "Opmerkingen",
  "safety-report-detail.comments.unknown-author": "Onbekende auteur",
  "safety-report-detail.fields.project": "Project",
  "safety-report-detail.fields.reporter": "Melder",
  "safety-report-detail.fields.category": "Categorie",
  "safety-report-detail.fields.urgency": "Urgentie",
  "safety-report-detail.fields.created-at": "Aangemaakt op",
  "safety-report-detail.fields.solved-at": "Opgelost op",
  "safety-report-detail.fields.description": "Beschrijving",
  "safety-report-detail.fields.risk": "Risico",
  "safety-report-detail.fields.photos": "Foto's",
  "safety-report-detail.fields.current-status": "Huidige status",
  "safety-report-detail.fields.assigned-to": "Toegewezen aan",
  "safety-report-detail.unassigned": "Niet toegewezen",
  "safety-report-detail.status-editing-note": "Status en toewijzing kunnen alleen worden gewijzigd door gebruikers met de juiste rechten.",
  "safety-report-detail.no-logs": "Geen logboek beschikbaar.",
  "safety-report-detail.log.created": "Melding aangemaakt door {{actorName}}",
  "safety-report-detail.log.status-changed": "Status gewijzigd door {{actorName}} naar {{newStatus}}",
  "safety-report-detail.log.commented": "Opmerking toegevoegd door {{actorName}}",
  "safety-report-detail.log.assigned": "Toegewezen aan {{assignedToPersonName}} door {{actorName}}",
  "safety-report-detail.log.unassigned": "Niet meer toegewezen aan persoon door {{actorName}}",
  "safety-report-detail.log.unknown": "Onbekende logregel",
  "safety-report-detail.save-success": "Veiligheidsrapport succesvol bijgewerkt.",
  "safety-report-detail.save-error": "Bijwerken van veiligheidsrapport mislukt.",
  "safety-report-detail.validation-error": "Los eerst de fouten in het formulier op.",

  "safety-reports.create-new": "Nieuw Veiligheidsrapport",
  "safety-report-create.title": "Veiligheidsrapport Aanmaken",
  "safety-report-form.general-information": "Algemene Informatie",
  "safety-report-form.details": "Details",
  "safety-report-form.category": "Categorie",
  "safety-report-form.project": "Project",
  "safety-report-form.risk-category": "Risicocategorie",
  "safety-report-form.risk": "Risico",
  "safety-report-form.description": "Beschrijving",
  "safety-report-form.photos": "Foto's",
  "safety-report-form.click-to-upload-photos": "Klik om foto's te uploaden",
  "safety-report-form.selected-photos": "Geselecteerde Foto's",
  "safety-report-form.urgent": "Urgent",
  "safety-report-form.solved": "Opgelost",
  "safety-report-form.create-success": "Veiligheidsrapport succesvol aangemaakt.",
  "safety-report-form.create-error": "Er is een fout opgetreden bij het aanmaken van het veiligheidsrapport.",
  "safety-report-form.validation-error": "Los eerst de fouten in het formulier op.",
  "safety-report-form.description-or-photos-required": "Beschrijving of foto's zijn verplicht.",
  "safety-report-form.invalid-file-type": "Ongeldig bestandstype. Selecteer een afbeeldingsbestand.",
  "safety-report-form.file-too-large": "Bestandsgrootte te groot. Maximale grootte is 5MB.",

  "safety-report.fields.actions-taken": "Acties Onderzocht",
  "safety-report.fields.victims": "Slachtoffers",
  "safety-report.fields.absenteeism": "Verzuim",
  "safety-report.fields.hospitalised": "Ziekenhuisopname",

  "safety-report-detail.add-comment": "Opmerking toevoegen",
  "safety-instructions.title": "Veiligheidsinstructies",
  "safety-instructions.create": "Nieuwe veiligheidsinstructie",
  "safety-instructions.table.title": "Titel",
  "safety-instructions.table.type": "Type",
  "safety-instructions.table.organisation": "Organisatie",
  "safety-instructions.table.project": "Project",
  "safety-instructions.table.status": "Status",
  "safety-instructions.edit.title": "Veiligheidsinstructie bewerken",
  "safety-instructions.new.title": "Nieuwe veiligheidsinstructie",
  "safety-instructions.delete-button": "Veiligheidsinstructie verwijderen",
  "safety-instructions.delete-title": "Veiligheidsinstructie verwijderen",
  "safety-instructions.delete-message": "Weet je zeker dat je deze veiligheidsinstructie wilt verwijderen?",
  "safety-instructions.delete-confirm": "Verwijderen",
  "safety-instructions.toast.load-error": "Laden van veiligheidsinstructie mislukt.",
  "safety-instructions.toast.delete-success": "Veiligheidsinstructie succesvol verwijderd.",
  "safety-instructions.toast.delete-error": "Verwijderen van veiligheidsinstructie mislukt.",

  "safety-instructions.create-modal.header": "Veiligheidsinstructie aanmaken",
  "safety-instructions.create-modal.title": "Titel",
  "safety-instructions.create-modal.type": "Type",
  "safety-instructions.create-modal.type.generic": "Algemeen",
  "safety-instructions.create-modal.type.video": "Video",
  "safety-instructions.create-modal.type.required": "Type is verplicht",
  "safety-instructions.create-modal.cancel": "Annuleren",
  "safety-instructions.create-modal.create": "Aanmaken",

  "safety-instruction-form.details": "Details",
  "safety-instruction-form.name": "Naam",
  "safety-instruction-form.name.required": "Naam is verplicht",
  "safety-instruction-form.name.maxlength": "Naam mag niet langer zijn dan 200 karakters",
  "safety-instruction-form.type": "Type",
  "safety-instruction-form.type.Generic": "Algemeen",
  "safety-instruction-form.type.Video": "Video",
  "safety-instruction-form.created-by": "Aangemaakt door",
  "safety-instruction-form.owner": "Eigenaar",
  "safety-instruction-form.click-to-upload-thumbnail": "Klik om logo te uploaden",
  "safety-instruction-form.thumbnail": "Logo",
  "safety-instruction-form.remove-thumbnail": "Verwijder logo",
  "safety-instruction-form.using-organisation-logo": "Logo van organisatie",
  "safety-instruction-form.status": "Status",
  "safety-instruction-form.status-draft": "Concept",
  "safety-instruction-form.status-published": "Gepubliceerd",
  "safety-instruction-form.usable-in-swi": "Start Werk Instructie",
  "safety-instruction-form.usable-in-swi-label": "Bruikbaar in SWI / dagregistratie",
  "safety-instruction-form.video": "Video",
  "safety-instruction-form.save-validation": "Los eerst de fouten in het formulier op.",
  "safety-instruction-form.save-error": "Er is een fout opgetreden bij het opslaan van de veiligheidsinstructie.",
  "safety-instruction-form.save-success": "Veiligheidsinstructie succesvol opgeslagen.",
  "safety-instruction-form.save-name-not-translated": "Naam is niet vertaald in alle geselecteerde talen",
  "safety-instruction-form.blocks": "Blokken",
  "content-blocks.text": "Tekst",
  "content-blocks.text-placeholder": "Voer hier tekst in",
  "content-blocks.image": "Afbeelding",
  "content-blocks.image.drop-image": "Sleep afbeelding hierheen",
  "content-blocks.image.or-click-to-select": "of klik om te selecteren",
  "content-blocks.document": "Document",
  "content-blocks.document.drop-document": "Sleep PDF hierheen",
  "content-blocks.document.or-click-to-select": "of klik om te selecteren",
  "content-blocks.document.download": "Document downloaden",
  "content-blocks.video": "Video",
  "content-blocks.video.video-url": "Video URL",
  "content-blocks.video.preview": "Videovoorbeeld",
  "content-blocks.video.unsupported": "Alleen video's van https://youtube.com en https://vimeo.com worden ondersteund",
  "content-blocks.multiple-choice-question": "Meerkeuzevraag",
  "content-blocks.mcq.question": "Vraag",
  "content-blocks.mcq.question-placeholder": "Voer hier uw vraag in",
  "content-blocks.mcq.answers": "Antwoorden",
  "content-blocks.mcq.answer-placeholder": "Voer antwoord in",
  "content-blocks.mcq.correct": "Correct",
  "content-blocks.mcq.add-answer": "Antwoord Toevoegen",
  "content-blocks.mcq.all-correct-answers-required": "Alle juiste antwoorden moeten worden geselecteerd",
  "content-blocks.mcq.question-required": "Vraag is verplicht",
  "content-blocks.mcq.answer-required": "Antwoord is verplicht",
  "content-blocks.mcq.correct-answers-required": "Ten minste één correct antwoord is vereist",
  "content-blocks.page-separator": "Paginascheiding",
  "content-blocks.page-separator-placeholder": "Voer paginatitel in",

  "checklists.title": "Checklists",
  "checklists.create": "Nieuwe Checklist",
  "checklists.status": "Status",
  "checklists.organisation": "Organisatie",
  "checklists.project": "Project",
  "checklists.created-by": "Aangemaakt door",
  "checklists.created-at": "Aangemaakt op",
  "checklists.status.concept": "Concept",
  "checklists.status.published": "Gepubliceerd",

  "checklists.create-modal.header": "Checklist aanmaken",
  "checklists.create-modal.title": "Titel",
  "checklists.create-modal.title.required": "Titel is verplicht",
  "checklists.create-modal.create": "Aanmaken",
  "checklists.create-modal.error.create-failed": "Checklist aanmaken mislukt",

  "create-checklist-modal.error.create-failed": "Checklist aanmaken mislukt",

  "checklists.edit.placeholder": "Checklist inhoudseditor zal hier worden geïmplementeerd. Je kunt de titel, beschrijving en checklist items bewerken.",
  "checklists.edit.notFound": "Checklist niet gevonden",

  "checklists.delete-title": "Checklist verwijderen",
  "checklists.delete-message": "Weet je zeker dat je deze checklist wilt verwijderen? Deze actie kan niet ongedaan worden gemaakt.",
  "checklists.delete-confirm": "Verwijderen",
  "checklists.delete-success": "Checklist succesvol verwijderd",
  "checklists.delete-error": "Kon checklist niet verwijderen",

  "checklists.publish": "Publiceren",
  "checklists.publish-title": "Checklist publiceren",
  "checklists.publish-message": "Weet je zeker dat je deze checklist wilt publiceren? Eenmaal gepubliceerd kunnen de checklist items niet meer worden bewerkt en kan de status niet terug worden gewijzigd.",
  "checklists.publish-confirm": "Publiceren",
  "checklists.publish-success": "Checklist succesvol gepubliceerd",
  "checklists.publish-error": "Kon checklist niet publiceren",
  "checklists.publish-error-new-checklist": "Dit is een nieuwe checklist. Sla het eerst op voordat je publiceert.",
  "checklists.publish-error-unsaved-changes": "Sla je wijzigingen op voordat je publiceert.",
  "checklists.publish-error-not-concept": "Alleen checklists in de status Concept kunnen worden gepubliceerd.",

  "checklists.item.delete-title": "Item verwijderen",
  "checklists.item.delete-message": "Weet je zeker dat je dit checklist item wilt verwijderen?",
  "checklists.item.delete-confirm": "Verwijderen",

  "checklists.save-success": "Checklist succesvol opgeslagen",
  "checklists.save-error": "Kon checklist niet opslaan",

  "checklists.error.id-not-found": "Checklist ID niet gevonden",
  "checklists.error.load-failed": "Kon checklist niet laden",

  "checklist-form.title": "Titel",
  "checklist-form.title.required": "Titel is verplicht",
  "checklist-form.title.maxlength": "Titel mag niet langer zijn dan 200 karakters",
  "checklist-form.status": "Status",
  "checklist-form.description": "Beschrijving",
  "checklist-form.usable-in-swi": "Start Werk Instructie",
  "checklist-form.usable-in-swi-label": "Bruikbaar in SWI / dagregistratie",
  "checklist-form.items": "Checklist Items",
  "checklist-form.item.placeholder": "Voer checklist item in...",
  "checklist-form.item.required": "Item tekst is verplicht",
  "checklist-form.item.maxlength": "Item tekst mag niet langer zijn dan 500 karakters",
  "checklist-form.item.move-up": "Item omhoog verplaatsen",
  "checklist-form.item.move-down": "Item omlaag verplaatsen",
  "checklist-form.item.remove": "Item verwijderen",
  "checklist-form.add-item": "Item toevoegen",
  "checklist-form.save-validation": "Herstel de formulierfouten voordat je opslaat",
  "checklist-form.save-title-not-translated": "Titel is niet vertaald in alle geselecteerde talen",
  "checklist-form.save-items-not-translated": "Niet alle items zijn vertaald in alle geselecteerde talen",

  "thesaurus.title": "Platformthesaurus beheren",
  "thesaurus.add-node": "+ Knooppunt toevoegen",
  "thesaurus.error": "Kan thesaurusgegevens niet laden",
  "thesaurus.edit-function": "Functie Bewerken",
  "thesaurus.add-function": "Functie Toevoegen",
  "thesaurus.function-name": "Functienaam",
  "thesaurus.function-name-placeholder": "Voer functienaam in",
  "thesaurus.function-description": "Beschrijving",
  "thesaurus.function-description-placeholder": "Voer functiebeschrijving in",
  "thesaurus.synonyms": "Synoniemen",
  "thesaurus.synonyms-placeholder": "Synoniemen toevoegen",
  "thesaurus.non-selectable": "Niet-selecteerbaar",
  "thesaurus.non-selectable-label": "Deze node kan niet als functie geselecteerd worden",
  "thesaurus.management-organisation": "Beheerorganisatie",
  "thesaurus.load-organisations-error": "Fout bij het laden van organisaties",
  "thesaurus.save-edit-success": "Functie bijgewerkt",
  "thesaurus.save-new-success": "Functie aangemaakt",
  "thesaurus.save-error": "Opslaan van functie mislukt",
  "thesaurus.save-name-not-translated": "Naam is niet vertaald in alle geselecteerde talen",
  "thesaurus.save-description-not-translated": "Beschrijving is niet vertaald in alle geselecteerde talen",
  "thesaurus.delete-title": "Functie verwijderen",
  "thesaurus.delete-message": "Weet je zeker dat je deze functie wilt verwijderen? Deze actie kan niet ongedaan worden gemaakt.",
  "thesaurus.delete-confirm": "Verwijderen",
  "thesaurus.delete-success": "Functie succesvol verwijderd",
  "thesaurus.delete-error": "Verwijderen van functie mislukt",
  "thesaurus.cannot-delete-parent-function": "Kan een functie met kinderen niet verwijderen. Verwijder of verplaats eerst de kinderen.",

  "safety-requirements.title": "Veiligheidseisen",
  "safety-requirements.create": "Nieuwe Veiligheidseis",
  "safety-requirements.create-success": "Veiligheidseis succesvol aangemaakt",
  "safety-requirements.create-error": "Aanmaken van veiligheidseis mislukt",
  "safety-requirements.update-success": "Veiligheidseis succesvol bijgewerkt",
  "safety-requirements.update-error": "Bijwerken van veiligheidseis mislukt",
  "safety-requirements.delete-success": "Veiligheidseis succesvol verwijderd",
  "safety-requirements.delete-error": "Verwijderen van veiligheidseis mislukt",
  "safety-requirements.enable-requirement": "Eis inschakelen",
  "safety-requirements.disable-requirement": "Eis uitschakelen",
  "safety-requirements.enable-success": "Organisatie-eis succesvol ingeschakeld",
  "safety-requirements.enable-error": "Inschakelen van organisatie-eis mislukt",
  "safety-requirements.disable-success": "Organisatie-eis succesvol uitgeschakeld",
  "safety-requirements.disable-error": "Uitschakelen van organisatie-eis mislukt",
  "safety-requirements.type.Certificates": "Certificaten",
  "safety-requirements.type.Checklists": "Checklists",
  "safety-requirements.type.SafetyInstructions": "Veiligheidsinstructies",
  "safety-requirements.type.Toolboxes": "Toolboxen",
  "safety-requirements.edit.title": "Veiligheidseis bewerken",
  "safety-requirements.form.title": "Titel",
  "safety-requirements.form.title.placeholder": "Titel van de veiligheidseis",
  "safety-requirements.form.type": "Type veiligheidseis",
  "target-audience.form.include": "Doelgroep",
  "target-audience.form.exclude": "Uitsluiten",
  "target-audience.include-organisation": "Iedereen van organisatie meenemen",
  "target-audience.exclude-organisation": "Iedereen van organisatie uitsluiten",
  "target-audience.include-function": "Iedereen met functie meenemen",
  "target-audience.exclude-function": "Iedereen met functie uitsluiten",
  "target-audience.include-function-group": "Iedereen in functiegroep meenemen",
  "target-audience.exclude-function-group": "Iedereen in functiegroep uitsluiten",
  "target-audience.include-management": "Alleen leidinggevenden meenemen",
  "target-audience.exclude-management": "Leidinggevenden uitsluiten",
  "target-audience.include-everyone": "Iedereen meenemen",
  "target-audience.exclude-everyone": "Iedereen uitsluiten",
  "target-audience.everyone": "Iedereen",
  "target-audience.management": "Leidinggevenden",
  "target-audience.organisation.placeholder": "Organisatie",
  "target-audience.function.placeholder": "Functie of groep",
  "safety-requirements.add": "Veiligheidseis toevoegen",
  "safety-requirements.page-title": "Veiligheidseisen voor",
  "safety-requirements.include": "Meenemen:",
  "safety-requirements.exclude": "Uitsluiten:",
  "safety-requirements.none": "Geen",

  "organisation-safety-requirement.delete-title": "Veiligheidseis verwijderen",
  "organisation-safety-requirement.delete-message": "Weet je zeker dat je deze veiligheidseis wilt verwijderen? Deze actie kan niet ongedaan worden gemaakt.",
  "organisation-safety-requirement.delete-confirm": "Verwijderen",

  "project-safety-requirement.delete-title": "Veiligheidseis verwijderen",
  "project-safety-requirement.delete-message": "Weet je zeker dat je deze veiligheidseis wilt verwijderen? Deze actie kan niet ongedaan worden gemaakt.",
  "project-safety-requirement.delete-confirm": "Verwijderen",

  "safety-requirements.show-inherited-options": "Toon opties geërfd van",
  "safety-requirements.inherited-from-organisation": "Geërfd van organisatie",
  "safety-requirements.organisation-logo": "Organisatie logo",

  "field.visible-in-app": "Veld is zichtbaar in de app",
  "field.translation-original": "Origineel",
  "field.fill-with-ai": "Aanvullen met AI",
  "field.fill-with-ai.error": "Aanvullen met AI is mislukt, probeer het opnieuw",
  "field.ai-filled": "Door AI gegenereerd",
  "field.ai-filled.stale": "Origineel gewijzigd - opnieuw aanvullen met AI",

  "function-selector.title": "Selecteer functie",
  "function-selector.search.placeholder": "Zoek functies...",
  "function-selector.search.clear": "Wissen",
  "function-selector.search.no-results": "Geen resultaten gevonden",
  "function-selector.root": "Alle functies",
  "function-selector.select-this-category": "Selecteer deze categorie",
  "function-selector.cancel": "Annuleren",

  "organisation-edit.employees": "Medewerkers",
  "organisation-employees.page-title": "Medewerkers van {{organisation}}",
  "organisation-employees.name": "Naam",
  "organisation-employees.email": "E-mail",
  "organisation-employees.start-date": "In dienst sinds",
  "organisation-employees.function": "Functie",
  "organisation-employees.invitation-status": "Uitnodigingsstatus",

  "i18n.language-selector.select": "Selecteer talen",
  "i18n.language-selector.full.nl": "Nederlands (NL)",
  "i18n.language-selector.full.bg": "Bulgaars (BG)",
  "i18n.language-selector.full.de": "Duits (DE)",
  "i18n.language-selector.full.en": "Engels (EN)",
  "i18n.language-selector.full.pl": "Pools (PL)",
  "i18n.language-selector.full.pt": "Portugees (PT)",
  "i18n.language-selector.full.ro": "Roemeens (RO)",
  "i18n.language-selector.full.tr": "Turks (TR)",
  "i18n.language-selector.short.nl": "NL",
  "i18n.language-selector.short.bg": "BG",
  "i18n.language-selector.short.de": "DE",
  "i18n.language-selector.short.en": "EN",
  "i18n.language-selector.short.pl": "PL",
  "i18n.language-selector.short.pt": "PT",
  "i18n.language-selector.short.ro": "RO",
  "i18n.language-selector.short.tr": "TR",

  "toolboxes.title": "Lijst van toolboxen",
  "toolboxes.select-organisation-first": "Selecteer eerst een organisatie",
  "toolboxes.select-scope-first": "Selecteer eerst een bereik",
  "toolboxes.project-toolboxes": "Projecttoolboxen",
  "toolboxes.inherited-toolboxes": "Vanuit de organisatie",
  "toolboxes.no-project-toolboxes": "Geen toolboxen gevonden voor dit project.",
  "toolboxes.error-load-project-toolboxes": "Laden van de toolboxen voor dit project is mislukt",
  "toolboxes.create": "Nieuwe toolbox",
  "toolboxes.no-organisation-toolboxes": "Geen toolboxen gevonden voor deze organisatie.",
  "toolboxes.no-platform-toolboxes": "Er zijn geen platformtoolboxen.",
  "toolboxes.new.title": "Nieuwe Toolbox",
  "toolboxes.edit.title": "Toolbox bewerken",
  "toolboxes.platform": "Platform",
  "toolboxes.platform-option": "PLATFORM",
  "toolboxes.available-toolboxes": "Beschikbare toolboxen",
  "toolboxes.enabled-toolboxes": "Ingeschakelde toolboxen",
  "toolboxes.platform-toolboxes": "Platform toolboxen",
  "toolboxes.filter-administrative-organisation": "Administratieve organisatie",
  "toolboxes.filter-not-set": "Niet ingesteld",
  "toolboxes.no-platform-toolboxes-for-filter": "Geen platform toolboxen gevonden voor de geselecteerde administratieve organisatie.",
  "toolboxes.platform-toolbox-label": "Dit is een platform toolbox die is ingeschakeld voor deze organisatie",
  "toolboxes.assign-to-organisation": "Toewijzen aan organisatie",
  "toolboxes.remove-from-organisation": "Verwijderen uit organisatie",
  "toolboxes.enable-for-users": "Toolbox inschakelen voor gebruikers",
  "toolboxes.disable-for-users": "Toolbox uitschakelen voor gebruikers",
  "toolboxes.error-load-platform-toolboxes": "Laden van platform toolboxen mislukt.",
  "toolboxes.error-load-organisation-toolboxes": "Laden van organisatie toolboxen mislukt.",
  "toolboxes.error-load-platform-toolboxes-for-organisation": "Laden van platform toolboxen voor organisatie mislukt.",
  "toolboxes.error-assign-to-organisation": "Toewijzen van toolbox aan organisatie mislukt.",
  "toolboxes.error-remove-from-organisation": "Verwijderen van toolbox uit organisatie mislukt.",
  "toolboxes.error-enable-toolbox-for-users": "Inschakelen van toolbox voor gebruikers mislukt.",
  "toolboxes.error-disable-toolbox-for-users": "Uitschakelen van toolbox voor gebruikers mislukt.",
  "toolboxes.type-synchronous": "Synchroon",
  "toolboxes.type-asynchronous": "Asynchroon",

  "toolbox-edit.delete-button": "Verwijder Toolbox",
  "toolbox-edit.delete-title": "Verwijder Toolbox",
  "toolbox-edit.delete-message": "Weet je zeker dat je deze toolbox wilt verwijderen?",
  "toolbox-edit.delete-confirm": "Verwijderen",
  "toolbox-edit.toast.load-error": "Het laden van de toolbox is mislukt.",
  "toolbox-edit.toast.delete-success": "Toolbox succesvol verwijderd.",
  "toolbox-edit.toast.delete-error": "Het verwijderen van de toolbox is mislukt.",
  "toolbox-edit.toast.delete-conflict": "Kan een platformtoolbox die is ingeschakeld voor een organisatie niet verwijderen.",

  "toolbox-form.details": "Details",
  "toolbox-form.name": "Naam",
  "toolbox-form.name.required": "Naam is verplicht",
  "toolbox-form.name.maxlength": "Naam is te lang (max 200 tekens)",
  "toolbox-form.created-by": "Aangemaakt door",
  "toolbox-form.organisation": "Organisatie",
  "toolbox-form.project": "Project",
  "toolbox-form.administrative-organisation": "Administratieve organisatie",
  "toolbox-form.version": "Versie",
  "toolbox-form.status": "Status",
  "toolbox-form.type": "Type toolbox",
  "toolbox-form.type-synchronous": "Synchroon (op locatie)",
  "toolbox-form.type-asynchronous": "Asynchroon (individueel)",
  "toolbox-form.status-concept": "Concept",
  "toolbox-form.status-published": "Gepubliceerd",
  "toolbox-form.status-archived": "Gearchiveerd",
  "toolbox-form.thumbnail": "Logo",
  "toolbox-form.click-to-upload-thumbnail": "Klik om logo te uploaden",
  "toolbox-form.remove-thumbnail": "Verwijderen",
  "toolbox-form.using-organisation-logo": "Logo van organisatie",
  "toolbox-form.categories": "Categorieën",
  "toolbox-form.categories-placeholder": "Selecteer categorieën",
  "toolbox-form.categories-selected": "{{count}} categorieën geselecteerd",
  "toolbox-form.promote": "Promotie",
  "toolbox-form.promote-label": "Toon bovenaan",
  "toolbox-form.usable-in-swi": "Start Werk Instructie",
  "toolbox-form.usable-in-swi-label": "Bruikbaar in SWI / dagregistratie",
  "toolbox-form.description": "Beschrijving",
  "toolbox-form.blocks": "Inhoudsblokken",
  "toolbox-form.save-error": "Het opslaan van de toolbox is mislukt",
  "toolbox-form.save-success": "Toolbox succesvol opgeslagen",
  "toolbox-form.save-name-not-translated": "Naam is niet vertaald naar alle geselecteerde talen",
  "toolbox-form.save-description-not-translated": "Beschrijving is niet vertaald naar alle geselecteerde talen",
  "toolbox-form.save-validation": "Los eerst de fouten in het formulier op.",

  "toolbox-analysis.button": "Analyse",
  "toolbox-analysis.tab-title": "Analyse:",
  "toolbox-analysis.title": "Toolbox analyse:",
  "toolbox-analysis.details-title": "Details",
  "toolbox-analysis.details.toolbox-name": "Toolbox",
  "toolbox-analysis.details.toolbox-type": "Type toolbox",
  "toolbox-analysis.details.organisation-name": "Organisatie",
  "toolbox-analysis.categories": "Categorieën",
  "toolbox-analysis.organisation-title": "Organisatie",
  "toolbox-analysis.meetings-title": "Bijeenkomsten",
  "toolbox-analysis.table.started": "Gestart",
  "toolbox-analysis.table.ended": "Beëindigd",
  "toolbox-analysis.table.host": "Gastheer",
  "toolbox-analysis.table.participants": "Deelnemers",
  "toolbox-analysis.toast.load-error": "Kon bijeenkomsten niet laden.",
  "toolbox-analysis.toast.load-employees-error": "Kon medewerkers van de organisatie niet laden.",
  "toolbox-analysis.organisation.name": "Naam",
  "toolbox-analysis.organisation.last-followed": "Laatst gevolgd",
  "toolbox-analysis.organisation.not-followed": "Niet gevolgd",
  "toolbox-analysis.organisation.no-employees": "Geen medewerkers gevonden.",
  "toolbox-analysis.export": "Exporteren",
  "toolbox-analysis.csv.first-name": "Voornaam",
  "toolbox-analysis.csv.last-name": "Achternaam",
  "toolbox-analysis.csv.followed": "Gevolgd",
  "toolbox-analysis.csv.followed-yes": "Ja",
  "toolbox-analysis.csv.followed-no": "Nee",
  "toolbox-analysis.csv.last-followed": "Laatst gevolgd",

  "toolbox-organisations-analysis.table.toolboxes-followed": "Gevolgde toolboxen",
  "toolbox-organisations-analysis.empty": "Geen medewerkers gevonden.",
  "toolbox-organisations-analysis.toast.load-error": "Kon toolbox analyse niet laden.",
  "toolbox-organisations-analysis.toast.load-categories-error": "Kon toolboxcategorieën niet laden.",
  "toolbox-organisations-analysis.filters.from": "Van",
  "toolbox-organisations-analysis.filters.to": "Tot",
  "toolbox-organisations-analysis.filters.types": "Typen",
  "toolbox-organisations-analysis.filters.types.placeholder": "Selecteer typen...",
  "toolbox-organisations-analysis.filters.types.synchronous": "Synchroon",
  "toolbox-organisations-analysis.filters.types.asynchronous": "Asynchroon",
  "toolbox-organisations-analysis.filters.types.manual": "Handmatig",
  "toolbox-organisations-analysis.filters.categories": "Categorieën",
  "toolbox-organisations-analysis.filters.categories.placeholder": "Selecteer categorieën...",
  "toolbox-organisations-analysis.filters.categories-selected": "{{count}} categorieën geselecteerd",

  "toolbox-meeting.title": "Toolbox bijeenkomst:",
  "toolbox-meeting.details-title": "Details",
  "toolbox-meeting.details.toolbox-name": "Toolbox",
  "toolbox-meeting.details.toolbox-type": "Type toolbox",
  "toolbox-meeting.details.organisation-name": "Organisatie",
  "toolbox-meeting.start-date": "Startdatum",
  "toolbox-meeting.end-date": "Einddatum",
  "toolbox-meeting.host": "Gastheer",
  "toolbox-meeting.description": "Beschrijving",
  "toolbox-meeting.participants-count": "Deelnemers",
  "toolbox-meeting.participants-title": "Deelnemers",
  "toolbox-meeting.toast.load-error": "Kon bijeenkomstdetails niet laden.",

  "validation.optional-suffix": " (optioneel)",
  "validation.required": "Dit veld is verplicht",
  "validation.minlength": "De waarde is te kort, moet minimaal {{required}} tekens lang zijn (typ {{missing}} meer)",
  "validation.maxlength": "De waarde is te lang, mag maximaal {{required}} tekens bevatten ({{tooMany}} te veel)",
  "validation.email": "Ongeldig e-mailadres",
  "validation.min": "De waarde is te klein, moet {{required}} of groter zijn",
  "validation.max": "De waarde is te groot, moet {{required}} of kleiner zijn",
  "validation.dateValidator": "Ongeldige datum, moet tussen het jaar {{minYear}} en {{maxYear}} liggen",
  "validation.onlyLettersAndDigits": "Alleen letters en cijfers zijn toegestaan",
  "validation.anythingExceptOnlyWhitespaces": "Moet een teken bevatten, zoals een letter of een cijfer",
  "validation.unknown": "Onbekende fout opgetreden",

  "review-people.tab-title": "Recensie van dienstverbanden",
  "review-people.header": "Werkverzoeken",
  "review-people.description": "Beoordeel werkverzoeken vanuit de Personen-sectie.",
  "review-people.organisations.all": "Alle organisaties",
  "review-people.empty.no-organisations": "Er zijn geen werkverzoeken om te beoordelen voor jouw organisaties.",
  "review-people.approve.title": "Dienstverband goedkeuren",
  "review-people.approve.action": "Goedkeuren",
  "review-people.approve.confirm": "Goedkeuren",
  "review-people.approve.remark": "Opmerking voor de medewerker",
  "review-people.approve.remark-placeholder": "Waarom heb je het verzoek aangepast?",
  "review-people.approve.remark-hint": "Verplicht omdat je het verzoek hebt aangepast. De medewerker ziet de wijzigingen en deze opmerking in de app.",
  "review-people.reject.title": "Dienstverband afkeuren",
  "review-people.reject.message": "Weet je zeker dat je dit werkverzoek wilt afkeuren?",
  "review-people.reject.reason": "Reden voor afkeuring",
  "review-people.reject.action": "Afkeuren",
  "review-people.reject.confirm": "Afkeuren",
  "review-people.toast.approved": "Werkverzoek goedgekeurd.",
  "review-people.toast.rejected": "Werkverzoek afgekeurd.",
  "review-people.toast.forbidden": "Je hebt geen rechten om dienstverbanden voor {{organisationName}} te beheren.",
  "review-people.table.requested-on": "Aangevraagd op",
  "review-people.table.person": "Persoon",
  "review-people.table.email": "E-mail",
  "review-people.table.organisation": "Organisatie",
  "review-people.table.function": "Functie",
  "review-people.table.start-date": "Startdatum",
  "review-people.table.end-date": "Einddatum",

  "email-log.title": "E-maillog",
  "email-log.table.sent-at": "Verzonden op",
  "email-log.table.recipient": "Ontvanger",
  "email-log.table.type": "Type",
  "email-log.table.subject": "Onderwerp",
  "email-log.table.status": "Status",
  "email-log.type-PasswordReset": "Wachtwoordherstel",
  "email-log.type-Invitation": "Uitnodiging",
  "email-log.type-EmploymentReviewApproved": "Dienstverband goedgekeurd",
  "email-log.type-EmploymentReviewRejected": "Dienstverband afgewezen",
  "email-log.status-Sent": "Verzonden",
  "email-log.status-DeliveryError": "Bezorgfout",
  "email-log.status-FatalError": "Fatale fout",

  "": ""
}
